import "./NewBuildScaffolding.module.css";
import Header from "@/reusable_sections/Header";
import NewbuildScaffold from "./sections/NewbuildScaffold";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function NewBuildScaffoldingPage() {
  return <div>
      <Header />
      <NewbuildScaffold />
      <RelatedServices />
      <Footer />
    </div>;
}